import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    menuId: String,
  };

  onHamburgerClick(event) {
    const item = $(`#${this.menuIdValue}`);
    if (item.css('display') === 'none') {
      item.css('display', 'block');
    } else {
      item.css('display', 'none');
    }
  }
}
